import React, { Component } from 'react'
import { connect } from 'react-redux'
import { UserOverview as UserOverview24 } from 'projects/flow-gui-access/views/2.4/users'

class UserOverview extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'users').length !== 0) {
      return <UserOverview24 {...this.props} />
    } else {
      return null
    }
  }
}

export default connect(state => state)(UserOverview)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/users/overview.js